import type { Me, PermissionScope } from './types';

/**
 * Bir sayfanın / menünün görünme kuralı.
 *  - perm: izinlerden en az biri (dizi verilirse "herhangi biri")
 *  - feature: platformun tenant'a açtığı modül (kapalıysa sayfa hiç açılmaz)
 *  - entitlement: yalnızca kendi kapsamındaki (müşteri) kullanıcılar için abonelik hakkı
 *  - scope: 'tenant' ise izin personel kapsamında olmalı ('own' yetmez)
 */
export interface AccessRule {
  perm?: string | string[];
  scope?: PermissionScope;
  feature?: string;
  entitlement?: string;
}

export function scopeOf(me: Me, perm: string | string[]): PermissionScope | null {
  const codes = Array.isArray(perm) ? perm : [perm];
  let best: PermissionScope | null = null;
  for (const c of codes) {
    const s = me.permissions[c];
    if (s === 'tenant') return 'tenant';
    if (s === 'own') best = 'own';
  }
  return best;
}

export function can(me: Me, perm: string | string[], scope?: PermissionScope): boolean {
  const s = scopeOf(me, perm);
  if (!s) return false;
  return scope === 'tenant' ? s === 'tenant' : true;
}

export function hasFeature(me: Me, code: string): boolean {
  return me.access.tenantFeatures.includes(code);
}

export function isEntitled(me: Me, code: string): boolean {
  return code in me.access.features;
}

export function allowed(me: Me, rule: AccessRule): boolean {
  if (rule.feature && !hasFeature(me, rule.feature)) return false;
  if (rule.perm) {
    const s = scopeOf(me, rule.perm);
    if (!s) return false;
    if (rule.scope === 'tenant' && s !== 'tenant') return false;
    if (rule.entitlement && s === 'own' && !isEntitled(me, rule.entitlement)) return false;
  } else if (rule.entitlement && !isEntitled(me, rule.entitlement)) {
    return false;
  }
  return true;
}

/** Personel mi (herhangi bir izni tenant kapsamında)? Ana sayfa ve menü düzeni buna göre. */
export function isStaff(me: Me): boolean {
  return Object.values(me.permissions).some((s) => s === 'tenant');
}
